import theme from '@styles/theme';
export default {
  section: {
    backgroundColor: theme.rawColors.lightGrey300,
    padding: ['64px 16px', '64px 16px', '80px 24px', '80px 24px', '6.0416667vw 10.15625vw ']
  },
  container: {
    margin: '0 auto',
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'row'],
    gap: ['32px', '32px', '40px', '64px', '120px'],
    alignItems: ['stretch', 'stretch', 'stretch', 'flex-start']
  },
  infoColumn: {
    flex: 1,
    minWidth: 0
  },
  title: {
    marginBottom: '40px'
  },
  description: {
    p: {
      margin: 0,
      fontFamily: theme.fonts.uniformMedium,
      fontSize: theme.fontSizes.h4,
      lineHeight: '140%',
      color: theme.rawColors.darkGrey700
    }
  }
};